import {AuthLayout, DefaultLayout} from '../components/layouts';
import i18n from '../locale';

export const publicRoute = [
  { path: '*', redirect:'/', hidden: true },
  {
    path: '/',
    component: AuthLayout,
    meta: { title: 'Login' },
    redirect: '/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        meta: { title: 'Login' },
        component: () => import(/* webpackChunkName: "login" */ '../views/Login/Login.vue'),
      },
    ],
  },
  {
    path: '/403',
    name: 'Forbidden',
    hidden: true,
    meta: { title: 'Access Denied', hiddenInMenu: true },
    component: () => import(/* webpackChunkName: "error-403" */ '../views/error/Deny.vue'),
  },
  {
    path: '/404',
    name: '404',
    hidden: true,
    meta: { title: 'Not Found' },
    component: () => import(/* webpackChunkName: "errors-404" */ '../views/error/NotFound.vue'),
  },
  {
    path: '/500',
    name: '500',
    hidden: true,
    meta: { title: 'Server Error' },
    component: () => import(/* webpackChunkName: "errors-500" */ '../views/error/Error.vue'),
  },
];

export const protectedRoute = [
  {
    path: '/dashboard',
    component: DefaultLayout,
    meta: { title: 'Home', group: 'apps', icon: '' },
    redirect: '/dashboard',
    hidden: true,
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        meta: { title: 'Home', group: 'apps', icon: 'dashboard' },
        component: () => import(/* webpackChunkName: "dashboard" */ '../views/index.vue'),
      },
    ],
  },
  {
    path: '/setting',
    component: DefaultLayout,
    meta: { title: 'Setting', group: 'apps', icon: '' },
    redirect: '/setting/accountsetting',
    hidden: true,
    children: [
      {
        path: '/setting/accountsetting',
        name: 'Setting',
        meta: { title: i18n.t('menu.setting'), group: 'apps', icon: 'Setting' },
        component: () => import(/* webpackChunkName: "dashboard" */ '../views/Setting/index.vue'),
      },
    ],
  },
  // {
  //   path: '/help',
  //   component: DefaultLayout,
  //   meta: { title: i18n.tmenu('common_help_root'), icon: 'help_outline', group: 'apps' },
  //   redirect: '/help/glossary',
  //   children: [
  //     {
  //       path: '/help/glossary',
  //       name: 'FieldGlossary',
  //       meta: {
  //         title: i18n.tmenu('common_help_glossary'),
  //         parentTitle: i18n.tmenu('common_help_root'),
  //         menu_key: 'common_help_glossary',
  //         icon: 'menu_book',
  //       },
  //       component: () => import('@views/common/FieldGlossary.vue'),
  //     },
  //   ],
  // },
  {
    path: '/maintenance',
    component: DefaultLayout,
    meta: { title: i18n.t('menu.operationManagement'), icon: 'person_outline', group: 'operator', itemIdx: 1 },
    redirect: '/maintenance/operator',
    children: [
      {
        path: '/maintenance/operator',
        name: 'Operator Maintenance',
        meta: {
          parentTitle: i18n.t('menu.operationManagement'),
          title: i18n.t('menu.operatorMaintenance'),
          itemIdx: 2,
        },
        component: () => import('../views/OperationManagement/OperatorMaintenance/index.vue'),
      },
      {
        path: '/maintenance/group',
        name: i18n.t('menu.groupMaintenance'),
        meta: {
          parentTitle: i18n.t('menu.operationManagement'),
          title: i18n.t('menu.groupMaintenance'),
          itemIdx: 3,
        },
        component: () => import('../views/OperationManagement/GroupMaintenance/index.vue'),
      }
    ]
  },

  {
    path: '/provider',
    component: DefaultLayout,
    meta: { title: i18n.t('menu.ocmsDataMonitor'), icon: 'cloud_queue', group: 'ocmsDataMonitor', itemIdx: 70000 },
    redirect: '/provider/date',
    children: [
      { path: 'date', title: 'menu.siteDashboard', idx: 70101, view: 'Today/index.vue' },
      { path: 'trend', title: 'menu.siteTrend', idx: 70102, view: 'SiteTrend/index.vue' },
      { path: 'market', title: 'menu.marketTrend', idx: 70103, view: 'MarketTrend/index.vue' },
    ].map(item => ({
      path: `/provider/${item.path}`,
      name: `/provider/${item.path}`,
      meta: {
        parentTitle: i18n.t('menu.ocmsDataMonitor'),
        title: i18n.t(item.title),
        itemIdx: item.idx,
      },
      component: () => import(`../views/OCMS/Provider/${item.view}`),
    })),
  },

  {
    path: '/house',
    component: DefaultLayout,
    meta: { title: i18n.t('menu.ocmsHouseRoot'), icon: 'supervisor_account', groups: 'house', itemIdx: 80100 },
    redirect: '/house/siteRecap',
    children: [
      { path: 'siteRecap', title: 'menu.siteRecap', idx: 80102, view: 'SiteRecap/index.vue' },
      { path: 'memberTop', title: 'menu.memberTop', idx: 80103, view: 'MemberTop/index.vue' },
      { path: 'memberReg', title: 'menu.memberReg', idx: 80104, view: 'MemberReg/index.vue' },
      { path: 'memberCvt', title: 'menu.memberCvt', idx: 80105, view: 'MemberCvt/index.vue' },
      { path: 'lookup', title: 'menu.ocmsMemberLookup', idx: 80106, view: 'MemberLookup/index.vue' },
      { path: 'single', title: 'menu.ocmsCustomerSingle', idx: 80107, view: 'MemberSearch/index.vue' },
      { path: 'agentCompare', title: 'menu.ocmsAgentCompare', idx: 80108, view: 'AgentCompare/index.vue' },
      { path: 'promo/entire', title: 'menu.ocmsPromoEntire', idx: 80110, view: 'PromoRecap/index.vue' },
      { path: 'promoCompare', title: 'menu.ocmsPromoCompare', idx: 80111, view: 'PromoCompare/index.vue' },
      { path: 'date', title: 'menu.siteDateHouse', idx: 80201, view: 'Today/index.vue' },
      { path: 'trend', title: 'menu.siteTrendHouse', idx: 80202, view: 'SiteTrend/index.vue' },
    ].map(item => ({
      path: `/house/${item.path}`,
      name: `/house/${item.path}`,
      meta: {
        parentTitle: i18n.t('menu.ocmsHouseRoot'),
        title: i18n.t(item.title),
        itemIdx: item.idx,
      },
      component: () => import(`../views/OCMS/House/${item.view}`),
    })),
  },

  {
    path: '/onlineGeneral/general',
    component: DefaultLayout,
    meta: { title: i18n.t('menu.ocmsGeneral'), icon: 'insert_drive_file', group: 'onlineGeneral', itemIdx: 90000 },
    redirect: '/onlineGeneral/general/bankAccountung',
    children: [
      { path: 'bankAccountung', title: 'menu.bankAccounting', idx: 90001, view: 'BankAccounting/index.vue' },
      { path: 'serviceBanking', title: 'menu.serviceBanking', idx: 90002, view: 'ServiceBanking/index.vue' },
      { path: 'serviceCustomer', title: 'menu.serviceCustomer', idx: 90003, view: 'ServiceCustomer/index.vue' },
      { path: 'channel', title: 'menu.channel', idx: 90004, view: 'Channel/index.vue' },
      { path: 'memberActivity', title: 'menu.memberActivity', idx: 90005, view: 'MemberActivity/index.vue' },
      { path: 'memberDeposit', title: 'menu.memberDeposit', idx: 90006, view: 'MemberDeposit/index.vue' },
    ].map(item => ({
      path: `/onlineGeneral/general/${item.path}`,
      name: `/onlineGeneral/general/${item.path}`,
      meta: {
        parentTitle: i18n.t('menu.ocmsGeneral'),
        title: i18n.t(item.title),
        itemIdx: item.idx,
      },
      component: () => import(`../views/OCMS/General/${item.view}`),
    })),
  },

  {
    path: '/sys_provider',
    component: DefaultLayout,
    meta: { title: i18n.tmenu('sys_provider_root'), icon: 'lan', itemIdx: 91000 },
    children: [
      {idx: 91010, category: 'category_operation', path: 'site_compare', view: 'sys_provider/site_compare.vue'},

      {idx: 91021, category: 'category_gaming', path: 'gaming_stats', view: 'sys_provider/gaming_stats.vue'},
      {idx: 91028, category: 'category_gaming', path: 'game_theme_search', view: 'sys_provider/game_theme_search.vue'},
      {idx: 91030, category: 'category_gaming', path: 'game_retention', view: 'sys_provider/game_retention.vue'},

      {idx: 91040, category: 'category_promo', path: 'promo_stats', view: 'sys_provider/promo_stats.vue'},
      {idx: 91042, category: 'category_promo', path: 'promo_binding', view: 'sys_provider/promo_binding.vue'},
      {idx: 91050, category: 'category_promo', path: 'game_item_stats', view: 'sys_provider/game_item_stats.vue'},

      {idx: 91245, category: 'category_trans', path: 'trans_tppp_stats', view: 'sys_provider/trans_tppp_stats.vue'},

      {idx: 91300, category: 'category_network', path: 'network_probe_stats', view: 'sys_provider/network_probe_stats.vue'},
      {idx: 91305, category: 'category_network', path: 'network_http_stats', view: 'sys_provider/network_http_stats.vue'},
    ].map(item => ({
      path: `/sys_provider/${item.path}`,
      name: `/sys_provider/${item.path}`,
      meta: {
        itemIdx: item.idx,
        parentTitle: i18n.tmenu('sys_provider_root'),
        title: i18n.tmenu(`sys_provider_${item.path}`),
        menu_key: `sys_provider_${item.path}`,
        category: item.category,
      },
      component: () => import(`../views/${item.view}`),
    })),
  },

  {
    path: '/site_owner',
    component: DefaultLayout,
    meta: { title: i18n.tmenu('site_owner_root'), icon: 'bar_chart', itemIdx: 92000 },
    children: [
      {idx: 92010, category: 'category_operation', path: 'site_outline', view: 'site_owner/site_outline.vue'},
      {idx: 92055, category: 'category_operation', path: 'agent_stats', view: 'site_owner/agent_stats.vue'},

      {idx: 92061, category: 'category_gaming', path: 'gaming_stats', view: 'site_owner/gaming_stats.vue'},
      {idx: 92068, category: 'category_gaming', path: 'game_theme_search', view: 'site_owner/game_theme_search.vue'},
      {idx: 92070, category: 'category_gaming', path: 'game_retention', view: 'site_owner/game_retention.vue'},

      {idx: 92201, category: 'category_promo', path: 'promo_stats', view: 'site_owner/promo_stats.vue'},
      {idx: 92210, category: 'category_promo', path: 'promo_binding', view: 'site_owner/promo_binding.vue'},
      // {idx: 92220, category: 'category_promo', path: 'promo_manual', view: 'site_owner/promo_manual.vue'},
      // {idx: 92230, category: 'category_promo', path: 'promo_voucher', view: 'site_owner/promo_voucher.vue'},
      {idx: 92250, category: 'category_promo', path: 'game_item_stats', view: 'site_owner/game_item_stats.vue'},

      {idx: 92345, category: 'category_trans', path: 'trans_tppp_stats', view: 'site_owner/trans_tppp_stats.vue'},

      {idx: 92360, category: 'category_network', path: 'network_probe_stats', view: 'site_owner/network_probe_stats.vue'},
      {idx: 92365, category: 'category_network', path: 'network_http_stats', view: 'site_owner/network_http_stats.vue'},

      {idx: 92400, category: 'category_member', path: 'member_reg_age', view: 'site_owner/member_reg_age.vue'},
      {idx: 92410, category: 'category_member', path: 'member_returning', view: 'site_owner/member_returning.vue'},
      {idx: 92420, category: 'category_member', path: 'member_prank', view: 'site_owner/member_prank.vue'},
      {idx: 92430, category: 'category_member', path: 'member_level', view: 'site_owner/member_level.vue'},
      {idx: 92440, category: 'category_member', path: 'member_tag', view: 'site_owner/member_tag.vue'},
      // {idx: 92450, category: 'category_member', path: 'member_related', view: 'site_owner/member_related.vue'},
      {idx: 92600, category: 'category_member', path: 'member_search', view: 'site_owner/member_search.vue'},
      {idx: 92610, category: 'category_member', path: 'member_recap', view: 'site_owner/member_recap.vue'},
    ].map(item => ({
      path: `/site_owner/${item.path}`,
      name: `/site_owner/${item.path}`,
      meta: {
        itemIdx: item.idx,
        parentTitle: i18n.tmenu('site_owner_root'),
        title: i18n.tmenu(`site_owner_${item.path}`),
        menu_key: `site_owner_${item.path}`,
        category: item.category,
        is_single_site: true,
      },
      component: () => import(`../views/${item.view}`),
    })),
  },

  { path: '*', redirect: '/404', hidden: true },
];
